import PayoutsField from '@apps/truevail/admin/components/payoutsfield'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Issue extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {}

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      title: 't(Issue Payouts)',
      method: 'POST',
      action: '/api/admin/truevail/admin/payouts/issue',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Payouts)', 
              name: 'payout_ids', 
              type: PayoutsField,
              required: true 
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Issue
